import React, { useState } from "react";
import styles from "../css/styles.module.css";
import Select from "react-select";
import { selectStyle } from "./selectStyle";

export default function EditReport(props) {
  const [report, setReport] = useState({
    contact: props.report.contact,
    customer: props.report.customer,
    department: props.report.department,
    detail: props.report.detail,
    qtNumber: props.report.qtNumber,
    responsible: props.report.responsible,
    date: props.report.timestamp,
  });

  function handleChange(e) {
    setReport({
      ...report,
      [e.target.name]: e.target.value,
    });
  }

  //handle dropdow select change
  function handleSelectChange(selected, actionMeta) {
    setReport({
      ...report,
      [actionMeta.name]: selected.label,
    });
  }

  return (
    <div className={styles.form2}>
      <form
        className={styles.gridForm}
        onSubmit={(e) => {
          props.handleEditSubmit(e, report);
        }}
      >
        <h1 className={styles.gridFormMerge}>Edit Report</h1>
        <Select
          name="customer"
          styles={selectStyle}
          isSearchable
          defaultValue={{
            label: report.customer,
            value: report.customer,
          }}
          options={props.customer}
          onChange={(selected, actionMeta) =>
            handleSelectChange(selected, actionMeta)
          }
        />
        <input
          className={styles.noMargin}
          type="date"
          name="date"
          onChange={handleChange}
          value={report.date}
          required
        />
        <Select
          name="contact"
          styles={selectStyle}
          isSearchable
          defaultValue={{
            label: report.contact,
            value: report.contact,
          }}
          options={props.contact}
          onChange={(selected, actionMeta) =>
            handleSelectChange(selected, actionMeta)
          }
        />
        <input
          className={styles.noMargin}
          type="text"
          name="responsible"
          placeholder="Person Responsible"
          onChange={handleChange}
          value={report.responsible}
          required
        />
        <Select
          name="department"
          styles={selectStyle}
          isSearchable
          defaultValue={{
            label: report.department,
            value: report.department,
          }}
          options={props.departments}
          onChange={(selected, actionMeta) =>
            handleSelectChange(selected, actionMeta)
          }
        />
        <input
          type="text"
          name="qtNumber"
          value={report.qtNumber}
          onChange={handleChange}
        />
        <textarea
          className={styles.gridFormMerge}
          type="text"
          rows="4"
          name="detail"
          value={report.detail}
          onChange={handleChange}
          required
        />
        <button className={styles.gridFormMerge} type="submit">
          Confirm
        </button>
      </form>
      <button
        type="button"
        className={styles.cancelButton}
        onClick={() => props.handleCancelClick()}
      >
        Cancel
      </button>
    </div>
  );
}
